import { createTheme } from "@mui/material/styles";

const commonTypography = {
  fontFamily: "'Inter', sans-serif",
  h1: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  h2: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: 1.3,
  },
  h3: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: 1.4,
  },
  h4: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: 1.4,
  },
  body1: { fontSize: "16px", lineHeight: 1.6 },
  body2: { fontSize: "14px", lineHeight: 1.5 },
  caption: {
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "0.05em",
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#131b2e" },
    secondary: { main: "#0051d5" },
    background: { default: "#f8f9ff", paper: "#ffffff" },
    text: { primary: "#0b1c30", secondary: "#45464d" },
    error: { main: "#ba1a1a" },
    success: { main: "#009668" },
  },
  typography: commonTypography,
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          fontWeight: 700,
          fontSize: "12px",
          letterSpacing: "0.05em",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#bec6e0" },
    secondary: { main: "#b4c5ff" },
    background: { default: "#0b1c30", paper: "#131b2e" },
    text: { primary: "#f8f9ff", secondary: "#7c839b" },
    error: { main: "#ffdad6" },
    success: { main: "#4edea3" },
  },
  typography: commonTypography,
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          fontWeight: 700,
          fontSize: "12px",
          letterSpacing: "0.05em",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});
